var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcClosedFinger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM9.43039 6.29135C9.56548 6.29135 9.68021 6.34053 9.77476 6.43897C9.86933 6.53741 9.91674 6.65693 9.91667 6.79751V9.83473C9.91667 9.97529 9.86933 10.0949 9.77489 10.1933C9.68032 10.2917 9.56561 10.3409 9.43051 10.3409H4.56943C4.43445 10.3409 4.31964 10.2917 4.22511 10.1933C4.1306 10.0949 4.08333 9.97529 4.08333 9.83473V6.79757C4.08333 6.65688 4.13058 6.53733 4.22511 6.43897C4.31964 6.34053 4.43445 6.29135 4.56943 6.29135H4.73145V5.2789C4.73145 4.63208 4.95419 4.07674 5.39982 3.6127C5.84538 3.14868 6.37876 2.91667 6.99997 2.91667C7.6212 2.91667 8.15448 3.14868 8.60007 3.61272C9.0457 4.07674 9.26844 4.6321 9.26844 5.2789V6.29135H9.43039ZM5.70369 6.29135H8.29626V5.2789C8.29626 4.9063 8.16966 4.58813 7.91655 4.32455C7.66332 4.06089 7.35792 3.92912 7.00003 3.92912C6.64217 3.92912 6.33669 4.06091 6.08348 4.32455C5.8303 4.58815 5.70369 4.9063 5.70369 5.2789V6.29135Z",
    fill: "#1477EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClosedFinger);
export default __webpack_public_path__ + "static/media/ic_closed_finger.7a0648580a3dd76f041dd2c9dfd2f2f4.svg";
export { ForwardRef as ReactComponent };